<div *ngIf="visitDetails"
     class="booking-summary mt-4">
  <div class="row bg-primary text-white py-3 notranslate">
    <div class="col-12 d-flex align-items-between justify-content-between">
      <div>
        <div class="h4 fw-bold text-white mb-3">
          {{ visitDetails.salonName }}
        </div>

        <div *ngFor="let treatment of visitDetails.treatments"
             class="mb-2 ps-md-3">
          <span class="fw-bolder">
            {{ treatment.treatmentName }}
          </span>
          <div class="d-md-inline">
            <span *ngIf="treatment.isDurationVisible && treatment.durationInMinutes"
                  class="ms-3">
              {{ treatment.durationInMinutes }}{{ 'SHARED.TIME-UNITS-ABBREV.MINUTES' | translate }}
            </span>
            <span *ngIf="treatment.isPriceVisible && treatment.price"
                  class="ms-2"
                  [ngClass]="{ 'ms-3': !treatment.isDurationVisible }">
              {{ treatment.price | currency: 'EUR' }}
            </span>
          </div>
        </div>

        <div *ngIf="visitDetails.totalPrice"
             class="h5 fw-bold text-white mt-3">
          {{ 'BOOKING-PART.BOOKING-COMPLETED.TOTAL' | translate }}: {{ visitDetails.totalPrice | currency: 'EUR' }}
        </div>
      </div>

      <div class="d-flex flex-column justify-content-between align-items-end">
        <div class="salon-logo shadow-sm bg-white"
             [ngStyle]="{ 'background-image': 'url(' + visitDetails.salonLogoUrl + ')' }">
        </div>
      </div>
    </div>
  </div>

  <div class="row bg-gray-100 text-secondary border-top border-bottom border-white py-3"
       *ngIf="visitDetails.visitDate">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <div>
        {{ visitDetails.visitDate | visitSlotDate:currentLang }}
      </div>
    </div>
  </div>

  <div class="row bg-gray-100 text-secondary border-top border-bottom border-white py-3">
    <div class="col-12 d-flex align-items-center justify-content-between">
      <ng-container [ngSwitch]="visitDetails.paymentType">
        <div *ngSwitchCase="PaymentType.InSalon"
             [translate]="'BOOKING-PART.STEPS-SUMMARY.PAY-IN-SALON'">
        </div>
        <div *ngSwitchDefault
             [translate]="'BOOKING-PART.STEPS-SUMMARY.PAY-ONLINE'">
        </div>
      </ng-container>
    </div>
  </div>
</div>
